import { createAuth0 } from '@auth0/auth0-vue'

import { appConfig } from '@/config'
import { CALLBACK_PATH } from '@/constants'

export default createAuth0(
  {
    domain: appConfig.auth0.domain,
    clientId: appConfig.auth0.clientId,
    useRefreshTokens: true,
    useRefreshTokensFallback: true, // Fallback to non-refresh token flow if refresh tokens aren't available
    authorizationParams: {
      redirect_uri: window.location.origin + CALLBACK_PATH,
      audience: appConfig.auth0.audience,
      scope: 'openid profile email offline_access',
    },
  },
  {
    skipRedirectCallback: true,
  }
)
